import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'agr-block-data-item',
  templateUrl: './agr-block-data-item.component.html',
  styleUrls: ['./agr-block-data-item.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AgrBlockDataItemComponent implements OnInit {
  @Input() label: string;
  @Input() value: string;

  constructor() { }

  ngOnInit() {
  }

}
